import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AppUtil } from '@app/utils/app.util';

@Component({
  templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit {

  @Input() severidade: string;
  @Input() detalhe: string;
  @Input() resumo: string;

  @Output() retorno = new EventEmitter<boolean>();

  icone: string;

  constructor(
    private ngbActiveModal: NgbActiveModal
  ) { }

  ngOnInit() {

    this.icone = AppUtil.severidade(this.severidade).icone;

  }

  ok() {

    this.retorno.emit(true);
    this.ngbActiveModal.close();

  }

}
